import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { LoggerService } from "src/service/logger.service";

/**
 * Class to handle guest data
 */
export class BIGGuestData {
  private _inputTelegram: string = "";
  private _code: string = "";
  private _date: string = "";
  private _time: string = "";
  private _idTimeSlot: number = -1;
  private _idCalendar: number = -1;
  private _idPaymentProfile: number = -1;
  private _extraInfo: string = "";
  private _isValidTelegram: boolean = false;
  private _uid: string = "";

  get code(): string {
    return this._code;
  }

  get uid(): string {
    return this._uid;
  }

  get date(): string {
    return this._date;
  }

  get time(): string {
    return this._time;
  }

  get idTimeSlot(): number {
    return this._idTimeSlot;
  }

  get idCalendar(): number {
    return this._idCalendar;
  }

  get idPaymentProfile(): number {
    return this._idPaymentProfile;
  }

  get extraInfo(): string {
    return this._extraInfo;
  }

  get isDeleteRequest(): boolean {
    return this.isRequestToDeleteCode();
  }

  get isValidTelegram(): boolean {
    return this._isValidTelegram;
  }

  constructor(telegramString: string) {
    this._inputTelegram = telegramString;

    this.upackTelegram(telegramString);
  }

  /**
   * Unpack telegram string into specific telegram object property
   *
   * @param inputTelegram Input telegram
   */
  private upackTelegram(inputTelegram: string) {
    try {
      this._code = inputTelegram.substring(0, 6);
      this._date = inputTelegram.substring(6, 14);
      this._time = inputTelegram.substring(14, 18);
      this._idTimeSlot = Number(inputTelegram.substring(18, 24));
      this._idCalendar = Number(inputTelegram.substring(24, 30));
      this._idPaymentProfile = Number(inputTelegram.substring(30, 36));
      this._extraInfo = inputTelegram.substring(36, 6);
      if (inputTelegram.length == 44) {
        this._uid = inputTelegram.substring(36, 44);
      }

      this._isValidTelegram = true;
    } catch (exception) {
      LoggerService.logStatic(
        LogLevel.LOG_ERROR,
        "Big-guest-data",
        "Big-guest-data",
        "upackTelegram()",
        "Error unpacking telegram: " +
          (exception?.message ?? JSON.stringify(exception))
      );

      this._isValidTelegram = false;
    }
  }

  /**
   * Establish if current telegram need to delete code request
   *
   * @returns
   */
  private isRequestToDeleteCode(): boolean {
    return (
      Number(
        this._inputTelegram.substring(6, this._inputTelegram.length - 8)
      ) == 0
    );
  }
}
